<template>
  <div class="zhuaqiu-trace-page">
    <img class="top-bg" src="/static/images/zq/bg2.png" />
    <div class="content-container">
      <img class="logo" src="/static/images/zq/logo.png" />
      <img class="system" src="/static/images/zq/system.png" />
      <img class="pitou2" src="/static/images/zq/pitou2.png" />
      <div class="result-content">
        <div class="white-box">
          <div class="result-text">
            <div class="text-line">
              <div class="text-label">企业信息：</div>
              <div class="text-value">{{ companyInfo }}</div>
            </div>
            <div class="text-line">
              <div class="text-label">经销商：</div>
              <div class="text-value">{{ dealer }}</div>
            </div>
            <div class="text-line">
              <div class="text-label">经销省份：</div>
              <div class="text-value">{{ province }}</div>
            </div>
            <div class="text-line">
              <div class="text-label">批次信息：</div>
              <div class="text-value">{{ batchInfo }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bar"></div>
      <img class="bottom2" src="/static/images/zq/bottom2.png" />
    </div>
    <!-- Trace页面内容 -->
  </div>
</template>

<style scoped>
.zhuaqiu-trace-page {
  width: 100vw;
  min-height: 100vh;
  background-image: url('/static/images/zq/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.top-bg {
  width: 100vw;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.content-container {
  position: relative;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
}

.logo {
  width: 16vw;
  height: auto;
  margin-top: 4vh;
}

.system {
  width: 85vw;
  height: auto;
  margin-top: 4vh;
}

.pitou2 {
  width: 45vw;
  height: auto;
  margin-top: 4vh;
}

.result-content {
  position: fixed;
  top: 55%;
  left: 50%;
  transform: translateX(-50%);
  width: 84vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
}

.white-box {
  width: 84vw;
  min-height: 20vh;
  background-color: white;
  border: 1px solid rgb(198, 0, 22);
  margin-bottom: 1.5vh;
  display: flex;
  align-items: center;
  padding-left: 3vw;
}

.result-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text-line {
  display: flex;
  align-items: center;
  margin-bottom: 0.5vh;
}

.text-label {
  font-size: 3.8vw;
  color: black;
  text-align: justify;
  text-align-last: justify;
  width: 30vw;
  flex-shrink: 0;
}

.text-value {
  font-size: 3.8vw;
  color: black;
  text-align: left;
  flex-grow: 1;
}

.text-line:last-child {
  margin-bottom: 0;
}

.bottom-bar {
  width: 100vw;
  height: 5vh;
  background-color: rgb(198, 0, 22);
  position: fixed;
  bottom: 0;
  left: 0;
}

.bottom2 {
  width: 50vw;
  height: auto;
  position: fixed;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

@media screen and (max-height: 600px) {
  .logo {
    width: 12vw;
  }

  .system {
    width: 75vw;
  }

  .pitou2 {
    width: 40vw;
  }

  .result-content {
    width: 74vw;
  }

  .white-box {
    width: 74vw;
  }
}
</style>

<script>
import { getTrace } from '../../api/api'
export default {
  name: 'ZhuaQiuTrace',
  data() {
    return {
      eno: '',
      code: '',
      traceResult: {},
      companyInfo: '秦皇岛抓球科技有限责任公司',
      dealer: '',
      province: '',
      batchInfo: ''
    }
  },
  methods: {
    queryTrace(code, eno) {
      getTrace(code, eno).then(res => {
        if (res.data.code != 200) {
          alert('查询失败');
        } else if (res.data.data) {
          this.traceResult = res.data.data;
          this.companyInfo = this.traceResult.customizeTradeColumn2 || '';
          this.dealer = this.traceResult.customizeTradeColumn3 || '';
          this.province = this.traceResult.customizeTradeColumn4 || '';
          this.batchInfo = this.traceResult.customizeTradeColumn1 || '';
        } 
      }).catch(err => {
        console.error('查询失败:', err);
        alert('查询失败，请稍后重试');
      });
    }
  },
  mounted() {
    const params = this.$route.query;
    const code = params.c;
    const eno = params.eno;
    if (eno) {
      this.eno = eno;
    }
    if (code) {
      this.code = code ? code.substring(0, 16) : '';
    }
    this.queryTrace(this.code, this.eno);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuaQiu/Trace.vue